import Logo from './Logo';
import NoColorLogo from './no-color-logo.svg';
export const logoWidth = 117;

export { Logo, NoColorLogo };
